var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { useTabContext } from "./Tab.context";
import { addIconSVG } from "../../technical-fundamental/Icon/Icon/Icon.utils";
var TabsTab = forwardRef(function (_a, ref) {
    var children = _a.children, idTab = _a.idTab, icon = _a.icon, iconSvg = _a.iconSvg, className = _a.className, style = _a.style, otherprops = __rest(_a, ["children", "idTab", "icon", "iconSvg", "className", "style"]);
    var _b = useTabContext(), onChange = _b.onChange, selected = _b.selected, handleKeyDown = _b.handleKeyDown;
    var handleClick = function () {
        if (onChange) {
            onChange(idTab);
        }
    };
    var tabClassName = "fr-tabs__tab";
    if (icon) {
        tabClassName += " fr-tabs__tab--icon-left " + icon;
    }
    if (iconSvg) {
        tabClassName += " fr-tabs__tab--icon-left fr-icon";
    }
    if (selected === idTab) {
        tabClassName += " fr-tabs__tab--active";
    }
    if (className) {
        tabClassName += " ".concat(className);
    }
    var _c = addIconSVG(iconSvg, tabClassName, style), finalClassName = _c.className, tabStyle = _c.style;
    return (React.createElement("li", { role: "presentation" },
        React.createElement("button", __assign({}, otherprops, { ref: ref, id: idTab, className: finalClassName, tabIndex: selected === idTab ? 0 : -1, role: "tab", "aria-selected": selected === idTab ? "true" : "false", "aria-controls": "".concat(idTab, "-panel"), onKeyDown: handleKeyDown, onClick: handleClick, style: tabStyle, type: "button" }), children)));
});
export default TabsTab;
